import Colors from '@/constants/Colors';
import styled from 'styled-components';

export const StyledDraggableText = styled.div`
  z-index: 999;
  font-family: comicSans;

  .draggable-text {
    user-select: none;
    font-weight: bold;
    color: black;
    line-height: ${(props) =>
      props.txt.specialFontSize
        ? props.stage.width * props.txt.specialFontSize + 'px'
        : props.txt.fontSize + 'vw'};

    &:not(.answered) {
      cursor: pointer;
      touch-action: manipulation;
    }

    &.correct {
      cursor: default;
      padding: 2px 8px;
      border-radius: 6px;
      color: ${Colors.success};
      border: 2px solid ${Colors.success};
      background: rgba(255, 255, 255, 0.8);
      &:has(.multiline) {
        margin-top: -3.2vw;
      }
      .txt {
        &.multiline {
          margin-top: -3px;
        }
      }
    }
    &.wrong {
      padding: 2px 8px;
      border-radius: 10px;
      color: ${Colors.error};
      border: 2px solid ${Colors.error};
      background: white;
      cursor: not-allowed;
    }

    .icon svg {
      font-size: ${(props) => props.txt.fontSize + 'vw'};
    }

    .txt {
      color: #585858;
      span {
        font-size: ${(props) =>
          props.txt.specialFontSize
            ? props.stage.width * props.txt.specialFontSize + 'px'
            : props.txt.fontSize + 'vw'};
      }
      &.multiline {
        text-align: center;
        display: flex;
        flex-direction: column;
        line-height: ${(props) =>
          props.txt.specialFontSize
            ? props.stage.width * props.txt.specialFontSize * 0.6
            : props.txt.fontSize * 1.1 + 'vw'};
        span {
          display: inline-block;
          font-size: ${(props) =>
            props.txt.fontSize
              ? props.stage.width * props.txt.specialFontSize * 0.8
              : props.txt.fontSize + 'vw'};
          &:first-child {
            //border-bottom: 1px solid black;
            //padding-bottom: 0;
          }
        }
      }
    }
  }
`;
